module.exports = __webpack_public_path__ + "static/media/three_quarters_back_left_picture.ba339d8d.png";